import React from "react";
import './low_data_state.scss'

const LowDataState = ({ tier, matchCount }) => {
  if (tier === 3) {
    return (
      <div className="low-data-state">
        <div className="low-data-state__count">
          <span className="low-data-state__number">{matchCount}</span>
          <span className="low-data-state__label">
            {matchCount === 1 ? "Match" : "Matches"}
          </span>
        </div>
        <p className="low-data-state__message">
          More buyers are posting Want-Listings daily. We'll alert you when new matches appear.
        </p>
      </div>
    );
  }

  // Tier 4 - zero matches
  return (
    <div className="low-data-state">
      <div className="low-data-state__icon">
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
          <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="1.5" />
          <path
            d="M16 10V18"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <circle cx="16" cy="22" r="1" fill="currentColor" />
        </svg>
      </div>
      <p className="low-data-state__message">
        You'll be notified when buyers post Want-Listings that match your property.
      </p>
    </div>
  );
};

export default LowDataState;
